module.exports = __webpack_public_path__ + "img/btn.37b87e5c.svg";